import { TextAlignment } from '@/src/components';
import { Checkbox, Input, Select } from '@/src/components/Antd';
import { Row } from '@/src/components/Layouts';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
// import {
//   //Input,
//   TextArea,
//   //
// } from 'src/components/Antd';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Icon } from '@/src/tools/icon';
import {
  EPreviewSize,
  SubscriptionBackgroundType,
} from '@/src/types/common/SalesChannel';
import { cloneDeep, set } from 'lodash';
import React from 'react';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import Switcher from 'src/components/SectionSwitcher';
import Slider from 'src/components/Slider/MarginSlider';
import Editor from 'src/constrains/BraftEditor';
import { EnumModuleType, errKeys } from 'src/constrains/DraggableModules/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumPosition } from 'src/types/common/common';
import css from './css.less';

//import { ResponsiveRichEdit } from 'src/components/Modules/Components';

//import { SeoTag } from '@/src/pages/SalesChannelContentEditor/common';
const _errKeys = errKeys[EnumModuleType.ResponsiveText];

const Text = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    staticData,
    onStaticChange,
    linkSet,
    disableTagCheckbox,
    breakpoint,
    specificError,
  } = props;

  const textBoxWidthErr = specificError[_errKeys.textBoxWidth] || [];
  const topPaddingErr = specificError[_errKeys.topPadding] || [];
  const bottomPaddingErr = specificError[_errKeys.bottomPadding] || [];
  const { moduleStyle, h1TagEnabled, content, textAlignment } = staticData;
  const [switcher, setSwitcher] = React.useState('moduleStyle');

  const handleStaticChange = (prop: string, v: any) => {
    const temp = cloneDeep(staticData);
    set(temp, prop, v);
    onStaticChange(temp);
  };

  switch (breakpoint) {
    case EPreviewSize.WIDE: {
      return (
        <React.Fragment>
          <Section bottomBorder>
            <ItemWrapper
              // title='Background Colour'
              containerClassName={css.colorPickerWidth}>
              <Checkbox
                checked={h1TagEnabled}
                disabled={disableTagCheckbox}
                onChange={(value) => {
                  handleStaticChange('h1TagEnabled', value);
                }}>
                Set as page H1 tag
              </Checkbox>
            </ItemWrapper>
          </Section>
          <Section>
            <Switcher
              selected={switcher}
              onChange={(v) => setSwitcher(v)}
              allSections={{
                moduleStyle: {
                  title: getI18n('general.moduleStyle'),
                  hasError: false,
                  child: (
                    <React.Fragment>
                      <Row
                        elements={[
                          {
                            child: (
                              <>
                                <ItemWrapper
                                  title={getI18n('general.topPadding')}>
                                  <Input
                                    error={topPaddingErr.length > 0}
                                    help={topPaddingErr.join('')}
                                    size={'large'}
                                    suffix={'px'}
                                    value={moduleStyle?.topPadding}
                                    onChange={(v: any) =>
                                      handleStaticChange(
                                        'moduleStyle.topPadding',
                                        v,
                                      )
                                    }
                                  />
                                </ItemWrapper>
                              </>
                            ),
                          },
                          {
                            child: (
                              <>
                                <ItemWrapper
                                  title={getI18n('general.bottomPadding')}>
                                  <Input
                                    error={bottomPaddingErr.length > 0}
                                    help={bottomPaddingErr.join('')}
                                    size={'large'}
                                    suffix={'px'}
                                    value={moduleStyle?.bottomPadding}
                                    onChange={(v: any) =>
                                      handleStaticChange(
                                        'moduleStyle.bottomPadding',
                                        v,
                                      )
                                    }
                                  />
                                </ItemWrapper>
                              </>
                            ),
                          },
                        ]}
                      />
                      <ItemWrapper title={'Background Type'}>
                        <Select
                          size={'large'}
                          options={[
                            {
                              label: 'None',
                              value: SubscriptionBackgroundType.NONE,
                            },
                            {
                              label: 'Colour',
                              value: SubscriptionBackgroundType.COLOR,
                            },
                          ]}
                          value={moduleStyle?.backgroundType}
                          onChange={(v: any) =>
                            handleStaticChange('moduleStyle.backgroundType', v)
                          }
                        />
                      </ItemWrapper>
                      <ItemWrapper title={''}>
                        <Checkbox
                          checked={moduleStyle?.fullWidth}
                          onChange={(checked) =>
                            handleStaticChange('moduleStyle.fullWidth', checked)
                          }>
                          {getI18n('general.fullwidthbackground')}
                        </Checkbox>
                      </ItemWrapper>
                      <Slider
                        title={getI18n('general.margintoTopEdge')}
                        value={moduleStyle?.marginToTop || 0}
                        onChange={(value) =>
                          handleStaticChange('moduleStyle.marginToTop', value)
                        }
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                      />
                      <Slider
                        title={getI18n('general.margintoBottomEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        value={moduleStyle?.marginToBottom || 0}
                        onChange={(value) =>
                          handleStaticChange(
                            'moduleStyle.marginToBottom',
                            value,
                          )
                        }
                      />
                      {!moduleStyle?.fullWidth && (
                        <React.Fragment>
                          <Slider
                            title={'Margin to Right Edge'}
                            value={moduleStyle?.marginToRight || 0}
                            onChange={(value) =>
                              handleStaticChange(
                                'moduleStyle.marginToRight',
                                value,
                              )
                            }
                            position={EnumPosition.right}
                          />
                          <Slider
                            title={'Margin to Left Edge'}
                            position={EnumPosition.left}
                            value={moduleStyle?.marginToLeft || 0}
                            onChange={(value) =>
                              handleStaticChange(
                                'moduleStyle.marginToLeft',
                                value,
                              )
                            }
                          />
                        </React.Fragment>
                      )}

                      {moduleStyle?.backgroundType ===
                        SubscriptionBackgroundType.COLOR && (
                        <ItemWrapper
                          title={getI18n('general.backgroundColour')}>
                          <ColorPicker
                            multi
                            onChange={(v) =>
                              handleStaticChange(
                                'moduleStyle.backgroundColor',
                                v,
                              )
                            }
                            color={moduleStyle?.backgroundColor}
                          />
                        </ItemWrapper>
                      )}
                    </React.Fragment>
                  ),
                },
                content: {
                  title: getI18n('general.sider.content'),
                  hasError: false,
                  child: (
                    <React.Fragment>
                      <Section bottomBorder>
                        <ItemWrapper title={getI18n('general.text')}>
                          <Editor
                            linkSet={linkSet}
                            data={content?.text}
                            onChange={({ data }) =>
                              handleStaticChange('content.text', data)
                            }
                          />
                        </ItemWrapper>
                      </Section>
                      <Section bottomBorder>
                        <ItemWrapper title={getI18n('general.textBoxWidth')}>
                          <Input
                            error={textBoxWidthErr.length > 0}
                            help={textBoxWidthErr.join('')}
                            suffix={'px'}
                            size={'large'}
                            value={content?.textBoxWidth}
                            onChange={(v) =>
                              handleStaticChange('content.textBoxWidth', v)
                            }
                          />
                        </ItemWrapper>
                      </Section>
                    </React.Fragment>
                  ),
                },
              }}
            />
          </Section>
        </React.Fragment>
      );
    }
    case EPreviewSize.TABLET: {
      return (
        <Section>
          <Switcher
            selected={switcher}
            onChange={(v) => setSwitcher(v)}
            allSections={{
              moduleStyle: {
                title: getI18n('general.moduleStyle'),
                hasError: false,
                child: (
                  <React.Fragment>
                    <Row
                      elements={[
                        {
                          child: (
                            <ItemWrapper title={getI18n('general.topPadding')}>
                              <Input
                                error={topPaddingErr.length > 0}
                                help={topPaddingErr.join('')}
                                size={'large'}
                                suffix={'px'}
                                value={moduleStyle?.topPadding}
                                onChange={(v: any) =>
                                  handleStaticChange(
                                    'moduleStyle.topPadding',
                                    v,
                                  )
                                }
                              />
                            </ItemWrapper>
                          ),
                        },
                        {
                          child: (
                            <>
                              <ItemWrapper
                                title={getI18n('general.bottomPadding')}>
                                <Input
                                  error={bottomPaddingErr.length > 0}
                                  help={bottomPaddingErr.join('')}
                                  size={'large'}
                                  suffix={'px'}
                                  value={moduleStyle?.bottomPadding}
                                  onChange={(v: any) =>
                                    handleStaticChange(
                                      'moduleStyle.bottomPadding',
                                      v,
                                    )
                                  }
                                />
                              </ItemWrapper>
                            </>
                          ),
                        },
                      ]}
                    />
                    <ItemWrapper title={''}>
                      <Checkbox
                        checked={moduleStyle?.fullWidth}
                        onChange={(checked) =>
                          handleStaticChange('moduleStyle.fullWidth', checked)
                        }>
                        {getI18n('general.fullwidthbackground')}
                      </Checkbox>
                    </ItemWrapper>
                    <Slider
                      value={moduleStyle?.marginToTop || 0}
                      onChange={(value) =>
                        handleStaticChange('moduleStyle.marginToTop', value)
                      }
                      title={getI18n('general.margintoTopEdge')}
                      customIcon={
                        <Icon type={'icontop1'} className={css.icon} />
                      }
                    />
                    <Slider
                      value={moduleStyle?.marginToBottom || 0}
                      onChange={(value) =>
                        handleStaticChange('moduleStyle.marginToBottom', value)
                      }
                      title={getI18n('general.margintoBottomEdge')}
                      customIcon={
                        <Icon type={'icontop1'} className={css.icon} />
                      }
                    />
                  </React.Fragment>
                ),
              },
              content: {
                title: getI18n('general.sider.content'),
                hasError: false,
                child: (
                  <React.Fragment>
                    <Section bottomBorder>
                      <ItemWrapper title={getI18n('general.text')}>
                        <Editor
                          disabled={true}
                          linkSet={linkSet}
                          data={content?.text}
                        />
                      </ItemWrapper>
                      <Slider
                        max={1000}
                        min={0}
                        title={getI18n('general.fontSizeMultiple')}
                        customIcon={
                          <Icon type={'icona-fontsize'} className={css.icon} />
                        }
                        value={content?.fontSizeMultiply}
                        onChange={(v) =>
                          handleStaticChange('content.fontSizeMultiply', v)
                        }
                        suffix={'%'}
                      />
                      <ItemWrapper title={getI18n('general.textAlignment')}>
                        <TextAlignment
                          value={content?.textAlignment}
                          onChange={(v) =>
                            handleStaticChange('content.textAlignment', v)
                          }
                        />
                        {/* //import {ResponsiveRichEdit} from
                        'src/components/Modules/Components'; 可用这个组件*/}
                      </ItemWrapper>
                    </Section>
                    <Section bottomBorder>
                      <ItemWrapper title={getI18n('general.textBoxWidth')}>
                        <Input
                          error={textBoxWidthErr.length > 0}
                          help={textBoxWidthErr.join('')}
                          suffix={'px'}
                          size={'large'}
                          value={content?.textBoxWidth}
                          onChange={(v) =>
                            handleStaticChange('content.textBoxWidth', v)
                          }
                        />
                      </ItemWrapper>
                    </Section>
                  </React.Fragment>
                ),
              },
            }}
          />
        </Section>
      );
    }
    case EPreviewSize.MOBILE: {
      return (
        <Section>
          <Switcher
            selected={switcher}
            onChange={(v) => setSwitcher(v)}
            allSections={{
              moduleStyle: {
                title: getI18n('general.moduleStyle'),
                hasError: false,
                child: (
                  <React.Fragment>
                    <Row
                      elements={[
                        {
                          child: (
                            <ItemWrapper title={getI18n('general.topPadding')}>
                              <Input
                                error={topPaddingErr.length > 0}
                                help={topPaddingErr.join('')}
                                size={'large'}
                                suffix={'px'}
                                value={moduleStyle?.topPadding}
                                onChange={(v: any) =>
                                  handleStaticChange(
                                    'moduleStyle.topPadding',
                                    v,
                                  )
                                }
                              />
                            </ItemWrapper>
                          ),
                        },
                        {
                          child: (
                            <>
                              <ItemWrapper
                                title={getI18n('general.bottomPadding')}>
                                <Input
                                  error={bottomPaddingErr.length > 0}
                                  help={bottomPaddingErr.join('')}
                                  size={'large'}
                                  suffix={'px'}
                                  value={moduleStyle?.bottomPadding}
                                  onChange={(v: any) =>
                                    handleStaticChange(
                                      'moduleStyle.bottomPadding',
                                      v,
                                    )
                                  }
                                />
                              </ItemWrapper>
                            </>
                          ),
                        },
                      ]}
                    />
                    <ItemWrapper title={''}>
                      <Checkbox
                        checked={moduleStyle?.fullWidth}
                        onChange={(checked) =>
                          handleStaticChange('moduleStyle.fullWidth', checked)
                        }>
                        {getI18n('general.fullwidthbackground')}
                      </Checkbox>
                    </ItemWrapper>
                    <Slider
                      value={moduleStyle?.marginToTop || 0}
                      onChange={(value) =>
                        handleStaticChange('moduleStyle.marginToTop', value)
                      }
                      title={getI18n('general.margintoTopEdge')}
                      customIcon={
                        <Icon type={'icontop1'} className={css.icon} />
                      }
                    />
                    <Slider
                      value={moduleStyle?.marginToBottom || 0}
                      onChange={(value) =>
                        handleStaticChange('moduleStyle.marginToBottom', value)
                      }
                      title={getI18n('general.margintoBottomEdge')}
                      customIcon={
                        <Icon type={'icontop1'} className={css.icon} />
                      }
                    />
                  </React.Fragment>
                ),
              },
              content: {
                title: getI18n('general.sider.content'),
                hasError: false,
                child: (
                  <React.Fragment>
                    <Section bottomBorder>
                      <ItemWrapper title={getI18n('general.text')}>
                        <Editor
                          disabled={true}
                          linkSet={linkSet}
                          data={content?.text}
                        />
                      </ItemWrapper>
                      <Slider
                        value={content?.fontSizeMultiply}
                        onChange={(v) =>
                          handleStaticChange('content.fontSizeMultiply', v)
                        }
                        max={1000}
                        min={0}
                        title={getI18n('general.fontSizeMultiple')}
                        customIcon={
                          <Icon type={'icona-fontsize'} className={css.icon} />
                        }
                        suffix={'%'}
                      />
                      <ItemWrapper title={getI18n('general.textAlignment')}>
                        <TextAlignment
                          value={textAlignment}
                          onChange={(value) =>
                            handleStaticChange('textAlignment', value)
                          }
                        />
                      </ItemWrapper>
                    </Section>
                    <Section bottomBorder>
                      <ItemWrapper title={getI18n('general.textBoxWidth')}>
                        <Input
                          error={textBoxWidthErr.length > 0}
                          help={textBoxWidthErr.join('')}
                          suffix={'px'}
                          size={'large'}
                          value={content?.textBoxWidth}
                          onChange={(v) =>
                            handleStaticChange('content.textBoxWidth', v)
                          }
                        />
                      </ItemWrapper>
                    </Section>
                  </React.Fragment>
                ),
              },
            }}
          />
        </Section>
      );
    }
    default: {
      return <React.Fragment></React.Fragment>;
    }
  }
};
export default Text;
